// Build a UPI deep link (upi://pay?...) that opens any UPI app (GPay/PhonePe/Paytm)
// pre-filled with the payee VPA, name, amount and a note. No gateway required.
export function buildUpiLink({ upi_id, payee_name, amount, note }) {
  const parts = [];
  if (upi_id && upi_id.trim()) parts.push(`pa=${encodeURIComponent(upi_id.trim())}`);
  parts.push(`pn=${encodeURIComponent((payee_name || "Payee").trim())}`);
  const amt = Number(amount || 0);
  if (amt > 0) parts.push(`am=${amt.toFixed(2)}`);
  parts.push("cu=INR");
  if (note && note.trim()) parts.push(`tn=${encodeURIComponent(note.trim().slice(0, 60))}`);
  return `upi://pay?${parts.join("&")}`;
}

// A UPI VPA looks like name@bank. Loose validation for a friendly hint.
export function isValidUpiId(v) {
  if (!v) return true; // optional — QR still works with just name/amount on some apps
  return /^[\w.\-]{2,}@[\w.\-]{2,}$/.test(v.trim());
}
